import React, { useState, useCallback } from 'react';
import HomageWalletPopup from 'Screens/CareOwner/SubComponents/NewCareRecipient/homageWalletPopup';

import './WalletDropdown.css';
import { getTopLeftOf, getTopRightOf, _attr } from 'Util/Utilities';

type WalletDropdownProps = {
  haveCard?: boolean;
  wallet?: any;
  coId?: any;
  completed_charges?: any;
  upcoming_charges?: any;
  teleconsult_charges?: any;
  onCardAdded: () => void;
  isShowTransactions?: boolean;
};

// prevent re-render on onCardAdded callback change
function propsCompare(p: WalletDropdownProps, n: WalletDropdownProps) {
  if (p.haveCard !== n.haveCard || p.wallet !== n.wallet || p.coId !== n.coId) {
    return false;
  }
  return true; // no re-render
}

export const WalletDropdown: React.FunctionComponent<WalletDropdownProps> =
  React.memo(
    ({
      haveCard,
      wallet,
      coId,
      onCardAdded,
      completed_charges,
      upcoming_charges,
      teleconsult_charges,
      isShowTransactions,
    }) => {
      const [walletShowing, setShowWallet] = useState(false);
      const [anchor, setAnchor]: any = useState();
      const [popupAlign, setPopupAlign]: any = useState('left');

      const showWallet = useCallback((e) => {
        const left = getTopLeftOf(e.currentTarget);
        const right = getTopRightOf(e.currentTarget);

        if (left.x <= right.x) {
          setAnchor(left);
          setPopupAlign('left');
        } else {
          setAnchor(right);
          setPopupAlign('right');
        }

        setShowWallet(true);
      }, []);

      const closeWallet = useCallback(() => setShowWallet(false), []);

      // when new card added, close the popup and invoke callback
      const cardUpdated = useCallback(() => {
        setShowWallet(false);
        onCardAdded();
      }, [onCardAdded]);

      return (
        <>
          <div
            onClick={showWallet}
            className='wd-wallet-dropdown h vc'
            have-card={_attr(haveCard)}
          >
            <img
              src={
                haveCard
                  ? '/self-serve/wallet@3x.png'
                  : '/self-serve/wallet-blue@3x.png'
              }
              alt=''
              width='13'
            />
            <span className='wd-wallet-txt'>
              {haveCard ? 'Wallet' : 'Wallet not setup'}
            </span>
            <img
              src={
                haveCard
                  ? '/self-serve/expand-wallet@3x.png'
                  : '/self-serve/expand-wallet-empty@3x.png'
              }
              alt=''
              width='7'
            />
          </div>
          {walletShowing && (
            <HomageWalletPopup
              align={popupAlign}
              coId={coId}
              anchor={anchor}
              onCloseDialog={closeWallet}
              onCardAdded={cardUpdated}
              setShowWallet={setShowWallet}
              wallet={wallet}
              completed_charges={completed_charges}
              upcoming_charges={upcoming_charges}
              teleconsult_charges={teleconsult_charges}
              isShowTransactions={isShowTransactions}
            />
          )}
        </>
      );
    },
    propsCompare
  );
